<template>
  <!--
      作者 GM.RJ
      描述：会员结构树
  -->
  <div class="common-seach-wrap">
    <el-tabs v-model="editableTabsValue" @tab-click="handleClick" @tab-remove="removeTab">
      <el-tab-pane
        :key="item.name"
        v-for="(item, index) in editableTabs"
        :label="item.title"
        :name="item.name"
        :closable="item.closable"
      >
        <!--结构树-->
        <Tree v-if="index == 0" @addTab = "addTab"></Tree>
        <div v-else>
            <User :user=item.user></User>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
import Tree from "./part/Tree";
import User from "./part/User";
export default {
  components: {
    Tree,
    User
  },
  data() {
    return {
      form: {
        status: 0,
      },
      editableTabsValue: '0',
      tabIndex: 1,
      editableTabs: [
        {
          title: "结构树",
          name: '0',
          closable: false
        }
      ]
    };
  },
  created() {

  },
  methods: {
    handleClick(tab, event) {
    },
    addTab(e) {
      console.log(e);
      // let newTabName = ++this.tabIndex + '';
      let newTabName = e.id.toString();
      this.editableTabs.push({
        title: e.nick_name,
        name: newTabName,
        closable: true,
        user: e
      });
      // this.editableTabsValue = newTabName;
    },
    removeTab(targetName) {
      let tabs = this.editableTabs;
      let activeName = this.editableTabsValue;
      if (activeName === targetName) {
        tabs.forEach((tab, index) => {
          if (tab.name === targetName) {
            let nextTab = tabs[index + 1] || tabs[index - 1];
            if (nextTab) {
              activeName = nextTab.name;
            }
          }
        });
      }
      this.editableTabsValue = activeName;
      this.editableTabs = tabs.filter(tab => tab.name !== targetName);
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/user/structure/index.vue